<ng-container *transloco="let t">
  @if (this.periods.length > 0) {

    <div>
      <p class="text-uppercase fst-normal d-inline-flex cursor-pointer" app-tooltip
          [tooltip]="{hr: raceCommercialItem?.internalDescription, en: raceCommercialItem?.internalDescriptionEng, it: raceCommercialItem?.internalDescriptionIta, slo: raceCommercialItem?.internalDescriptionSlo}"
          [languages]="languages"
          [position]="TooltipPosition.RIGHT_TOP">
        <app-language-output [hrLabel]="raceCommercialItem?.name"  [srLabel]="raceCommercialItem?.nameSr"  [bsLabel]="raceCommercialItem?.nameBs" [enLabel]="raceCommercialItem?.nameEng"
                             [itLabel]="raceCommercialItem?.nameIta" [siLabel]="raceCommercialItem?.nameSlo"
                             [defaultLanguage]="event?.defaultLanguage" [languages]="languages"/>
      </p>

      <div class="col-12">
        <div class="price-table">
          <div class="col-12 d-flex">
            <div class="col-4 col-md-3">
              <div class="col">
                <div class="cell end">
                  <div #prevEl class="pointer"><i class="bi bi-chevron-left cursor-pointer"
                  ></i>
                  </div>
                </div>
                <div class="cell red start">
                <span class="title-content">
                  {{ t("race.pricing.period") }}
                </span></div>
                <div class="cell red start">
                  <span class="content">{{ t("race.pricing.price") }}</span>
                </div>
              </div>
            </div>
            <div class="col-8 col-md-9">
              <swiper #periodsSwiper [slidesPerView]="3" [breakpoints]="breakpoints"
                      [navigation]="{ prevEl: prevEl, nextEl: nextEl }">
                @for (period of periods;track period.id;let last = $last;let ind = $index) {
                  <ng-template swiperSlide>
                    <div class="col">
                      <div class="cell center dark">
                    <span class="title-content fw-medium">
                                   T{{ ind + 1 }}
                    </span>
                      </div>
                      <div class="cell center light">
                    <span class="content">
                      {{ period.startDate | localizedDate:'shortDate' }}
                      -
                      {{ period.endDate | localizedDate:'shortDate' }}
                    </span>
                      </div>
                      <div class="cell center light">
                        <span
                          class="content fw-medium">{{ period.price | myCurrency:currencyLabel }}</span>
                      </div>
                    </div>
                  </ng-template>
                }
              </swiper>
            </div>
          </div>
          <div class="col-1">
            <div class="col">
              <div class="cell start ps-0">
                <div #nextEl class="pointer"><i
                  class="bi bi-chevron-right cursor-pointer"
                ></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
</ng-container>

